// Converts a string array to a string with a capitalized first letter

export const convertToString = (array: string[]) => {
  const string = array.join(', ');
  return string.charAt(0).toUpperCase() + string.slice(1);
};
